module.exports = __webpack_public_path__ + "static/media/colheitadeira2.866877c2.svg";